/* eslint-disable max-len */
import React from 'react';
function Survey() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19,3h-4.2c-0.4-1.2-1.5-2-2.8-2S9.6,1.8,9.2,3H5C4.9,3,4.7,3,4.6,3c-0.4,0.1-0.7,0.3-1,0.6C3.4,3.8,3.3,4,3.2,4.2 C3.1,4.5,3,4.7,3,5v14c0,0.3,0.1,0.5,0.2,0.8c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.5,1,0.5c0.1,0,0.3,0,0.4,0h14c1.1,0,2-0.9,2-2 V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z M11,15h6v2h-6V15z M17,9V7h-6v2H17z M11,13h6v-2h-6V13z M9,15H7v2h2V15z M9,7H7v2h2V7z M9,11H7v2h2V11z M12.8,3.6c0,0.4-0.3,0.8-0.8,0.8S11.2,4,11.2,3.6s0.3-0.8,0.8-0.8S12.8,3.1,12.8,3.6z" })));
}
export default Survey;
